const getSelectedOption = (basket, id, fallback) => {
  const item = basket?.find((i) => i.identifier === id)
  return item?.selectedOption?.identifier ?? fallback
}

export default getSelectedOption
